import { svg } from "lit";

const icon = (paths: ReturnType<typeof svg>) =>
  svg`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;

export const icons = {
  brand: svg`<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="9"/></svg>`,
  search: icon(svg`<circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/>`),
  download: icon(svg`<path d="M12 3v12"/><path d="M7 10l5 5 5-5"/><path d="M5 21h14"/>`),
  file: icon(svg`<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/>`),
  refresh: icon(svg`<path d="M21 12a9 9 0 1 1-2.64-6.36"/><path d="M21 3v6h-6"/>`),
  comment: icon(svg`<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>`),
  external: icon(svg`<path d="M14 4h6v6"/><path d="M10 14L20 4"/><path d="M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"/>`),
  chevron: icon(svg`<path d="M6 9l6 6 6-6"/>`),
  alert: icon(svg`<path d="M12 9v4"/><path d="M12 17h.01"/><path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>`),
  check: icon(svg`<circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/>`),
  info: icon(svg`<circle cx="12" cy="12" r="9"/><path d="M12 16v-4"/><path d="M12 8h.01"/>`),
  open: icon(svg`<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>`),
  plus: icon(svg`<path d="M12 5v14"/><path d="M5 12h14"/>`),
  logout: icon(svg`<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/>`),
  menu: icon(svg`<path d="M4 6h16"/><path d="M4 12h16"/><path d="M4 18h16"/>`),
  empty: icon(svg`<circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/><path d="M8 11h6"/>`),
};
